<template>
	<div class="question-container mod-box">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/console/library' }">题库管理</el-breadcrumb-item>
			<el-breadcrumb-item>{{ library.name }}</el-breadcrumb-item>
			<el-breadcrumb-item>题目管理</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="search-bar">
			<el-row>
				<el-col :span="12">
          <el-button type="primary" @click="handleCreate" size="small" style="margin-right: 10px;">添加题目</el-button>
					<!-- 题目导入 -->
					<question-import :library_id="library_id" @import-success="handleImportSuccess"></question-import>
          <el-button type="primary" @click="handleExport" size="small" style="margin-left:10px">导出题目</el-button>
				</el-col>
				<el-col :span="12">
					<div class="question-search">
						<el-input placeholder="请输入关键词" size="small" v-model="listParams.keyword" class="question-search-input" clearable @keyup.enter.native="search" @clear="search"></el-input>
						<el-button icon="el-icon-search" type="primary" size="small" class="search-button" @click="search">搜索</el-button>
					</div>
				</el-col>
			</el-row>
		</div>

		<el-table class="question-list" :data="questions" ref="questionTable" :row-key="getRowKeys" @selection-change="handleSelectionChange" style="width: 100%" v-loading="listLoading">
			<el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
			<el-table-column label="题目">
				<template slot-scope="scope">
					<div class="question-item">
						<div class="title">
							<span class="type">[{{ questionTypes[scope.row.type] }}]</span>
							{{ scope.$index + 1 + listParams.page_size * (listParams.page_index - 1) }}.{{ scope.row.title }}
						</div>
						<div class="images" v-if="scope.row.image.length > 0"><el-image :src="img" :preview-src-list="scope.row.image" v-for="(img, img_index) in scope.row.image" :key="img_index" fit="cover" class="image"></el-image></div>
						<ul class="option-list" v-if="'012'.indexOf(scope.row.type) !== -1">
							<li class="option-item" v-for="(option, index) in scope.row.options" :key="index">
								<i class="el-icon-success" v-if="option.right"></i>
								<i class="el-icon-error" v-else></i>
								<span>{{ option.text }}</span>
							</li>
						</ul>
						<ul class="fill-blank-list" v-else-if="scope.row.type === '3'">
							<li class="fill-blank-item" v-for="(fill_blank, index) in scope.row.fill_blanks" :key="index">填空{{ index + 1 }}答案：{{ fill_blank.answers.join('、') }}</li>
						</ul>
						<div class="explain">解析：{{ scope.row.explain || '无' }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<div class="actions">
				<el-button type="primary" size="small" @click="moveToLibraryDiaLog = true" v-if="selectQuestions.length > 0">批量移动</el-button>
				<el-button type="danger" size="small" @click="handleBatchDelete" v-if="selectQuestions.length > 0">批量删除</el-button>
			</div>

			<el-pagination background layout="total, sizes, prev, pager, next" :pager-count="5" :total="listParams.total" :page-size="listParams.page_size" :page-sizes="[10, 20, 50, 100]" :current-page.sync="listParams.page_index" @current-change="pageChange" @size-change="pageSizeChange"></el-pagination>
		</div>

		<!-- 移动题目到其他题库 -->
		<el-dialog :visible.sync="moveToLibraryDiaLog" :append-to-body="true" center title="选择移动到" width="500px">
			<div>
				<el-select v-model="selectLibraryId" filterable placeholder="请选择移动到哪个题目" style="width: 100%;"><el-option v-for="item in libraries" :key="item.id" :label="item.name" :value="item.id"></el-option></el-select>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="moveToLibraryDiaLog = false">取 消</el-button>
				<el-button type="primary" @click="confirmMove">确认移动</el-button>
			</div>
		</el-dialog>

		<!-- 题目编辑 -->
		<question-edit :questionData="question" @edit-ok="handleSaveQuestion" @close="questionEditClose" v-if="questionEdit"></question-edit>
	</div>
</template>

<script>
import QuestionEdit from '../Components/QuestionEdit.vue';
import QuestionImport from '../Components/QuestionImport.vue';
export default {
	components: {
		QuestionEdit,
		QuestionImport
	},
	props: {
		library_id: String
	},
	data() {
		return {
			library: {
				id: '',
				name: '',
        export_url:'',
			},
			listLoading: true,
			questions: [],
			listParams: {
				page_size: 10,
				page_page: 1,
				keyword: '',
				type: '',
				total: 0
			},

			// 移动题目
			selectQuestions: [], // 选择的题目列表
			selectLibraryId: '',
			libraries: [], // 用户的题库列表，数据量不大没问题,用来移动题目
			moveToLibraryDiaLog: false, // 显示移动题目到题库的弹框

			// 编辑题目
			question: null,
			questionEdit: false,

			questionTypes: {
				0: '单选题',
				1: '多选题',
				2: '判断题',
				3: '填空题',
				4: '问答题'
			}
		};
	},
	created() {
		this.getQuestions();
		this.getLibraries();
	},
	computed: {},
	methods: {
		getQuestions() {
			this.listLoading = true;
			this.$axios
				.get('/questions', {
					params: {
						library_id: this.library_id,
						...this.listParams
					}
				})
				.then(res => {
					this.listLoading = false;
					if (res.status === 'success') {
						this.questions = res.data.list;
						this.library = res.data.library;
						this.listParams.total = res.data.total;
					}
				});
		},

		pageChange(page_index) {
			this.listParams.page_index = page_index;
			this.getQuestions();
		},
		pageSizeChange(page_size) {
			this.listParams.page_size = page_size;
			this.getQuestions();
		},
		handleSelectionChange(val) {
			this.selectQuestions = val;
		},
		search() {
			this.listParams.page_index = 1;
			this.getQuestions();
		},

		getRowKeys(row) {
			return row.id;
		},
		// 获取题库列表,一次性获取全部的
		getLibraries() {
			this.$axios
				.get('/library/list', {
					params: {
						page_size: 100000
					}
				})
				.then(res => {
					if (res.status === 'success') {
						this.libraries = res.data.libraries;
					}
				});
		},
		// 确认移动
		confirmMove() {
			if (this.selectLibraryId === '') {
				this.$message.error('请选择移动到的题库');
				return;
			}

			let question_ids = [];
			this.selectQuestions.forEach(item => {
				question_ids.push(item.id);
			});
			this.$axios
				.post('/question/batch/move', {
					library_id: this.selectLibraryId,
					question_ids: question_ids
				})
				.then(res => {
					if (res.status === 'success') {
						this.selectQuestions = [];
						this.$refs.questionTable.clearSelection();
						this.moveToLibraryDiaLog = false;
						this.getQuestions();
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				});
		},

		handleBatchDelete() {
			let question_ids = [];
			this.selectQuestions.forEach(item => {
				question_ids.push(item.id);
			});
			this.$confirm('删除后将不可恢复，确认删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$axios
						.post('/question/delete', {
							question_ids: question_ids
						})
						.then(res => {
							if (res.status === 'success') {
								this.selectQuestions = [];
								this.$refs.questionTable.clearSelection();
								this.getQuestions();
								this.$message.success(res.message);
							} else {
								this.$message.error(res.message);
							}
						});
				})
				.catch(() => {});
		},

		handleDelete(index, row) {
			this.$confirm('删除后将不可恢复，确认删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$axios
						.post('/question/delete', {
							question_ids: [row.id]
						})
						.then(res => {
							if (res.status === 'success') {
								// 从列表中剔除
								this.questions.splice(index, 1);
								this.$message.success(res.message);
							} else {
								this.$message.error(res.message);
							}
						});
				})
				.catch(() => {});
		},

    handleExport(){
      // 导出成绩表
      window.open(this.library.export_url);
    },

		questionEditClose() {
			this.question = null;
			this.questionEdit = false;
		},

		// 编辑题目
		handleEdit(index, row) {
			this.question = row;
			this.questionEdit = true;
		},

		// 创建题目
		handleCreate() {
			this.question = null;
			this.questionEdit = true;
		},

		// 创建,编辑题目
		handleSaveQuestion(question) {
			this.question = null;
			this.questionEdit = false;

			this.$message.info('保存中');

			this.$axios
				.post('/question', {
					question: question,
					question_id: question.id,
					library_id: this.library_id
				})
				.then(res => {
					if (res.status === 'success') {
						this.$message.success(res.message);
						this.getQuestions();
					} else {
						this.$message.error(res.message);
					}
				});
		},

		// 题目导入成功
		handleImportSuccess() {
			this.getQuestions();
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.question-container {
	background: #fff;
	padding: 20px;

	.upload-demo {
		display: inline-block;
		margin-left: 10px;
	}

	.download-template {
		margin-left: 10px;
	}

	.search-bar {
		padding: 20px 0 10px;

		.question-search {
			text-align: right;

			.question-search-input {
				width: 250px;
				margin-right: 10px;
			}
		}
	}

	.pagination {
		margin-top: 20px;
		display: flex;

		.actions {
			flex: 1;
		}
	}

	// 题目相关
	.question-list {
		.question-item {
			// background: #f0f2f5;
			// margin: 10px 0;
			// padding: 10px;
			// border: 1px solid #EEECEC;
			line-height: 20px;
			position: relative;

			.title {
				font-size: 16px;
				line-height: 23px;

				.type {
					color: #888;
				}
			}

			.images {
				margin-top: 10px;

				.image {
					border: 1px solid #eeecec;
					width: 100px;
					height: 100px;
					margin: 0 10px 10px 0;
				}
			}

			.explain {
				color: #909399;
				margin: 10px 0 0;
			}

			.option-list {
				padding: 0;
				margin: 10px 0 0;
				list-style: none;

				.option-item {
					display: inline-block;
					margin-right: 20px;

					.el-icon-success {
						color: #67c23a;
						font-size: 18px;
						vertical-align: middle;
					}

					.el-icon-error {
						color: #f56c6c;
						font-size: 18px;
						vertical-align: middle;
					}

					span {
						vertical-align: middle;
						margin-left: 3px;
					}
				}
			}

			.fill-blank-list {
				padding: 0;
				margin: 10px 0 0;
				list-style: none;

				.fill-blank-item {
				}
			}
		}
	}
}
</style>
